import { assertResponse } from './response'

export async function fetchWithCredentials(idToken: string, url: string, init: RequestInit = {}): Promise<Response> {
  const params: RequestInit = {
    ...init,
    credentials: 'include',
    headers: {
      ...init.headers,
      Authorization: `Bearer ${idToken}`
    }
  }

  const res = await fetch(url, params)

  // Le corps d'une réponse en erreur peut porter un message métier
  // (cf. HandleConflict côté serveur). On le lit sur un clone pour ne pas
  // consommer le flux : l'appelant fait son propre res.json(). Sans cela,
  // l'erreur était levée ici, avant que quiconque ait pu lire le message.
  let result: any

  if (!res.ok) {
    try {
      result = await res.clone().json()
    } catch {
      // Corps absent ou non-JSON : on s'en tient au statut HTTP.
    }
  }

  assertResponse(res, result)

  return res
}
